<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Vestiging bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditBranchDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <div class="hogans-alerts">
      <v-alert v-if="feedback" :value="true" type="warning">
        {{ feedback }}
      </v-alert>
    </div>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-form ref="editBranchForm" lazy-validation>
        <v-expansion-panels accordion v-model="panel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <strong>Adresgegevens</strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              :color="$vuetify.theme.themes[theme].background"
            >
              <v-container grid-list-md fluid class="ma-0 px-0">
                <v-text-field
                  label="Vestigingsnaam"
                  v-model.trim="selectedBranch.branchName"
                  prepend-icon="business"
                  :rules="requiredRules"
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  hide-details
                  outlined
                  required
                ></v-text-field>

                <!-- / SALONHUB BRANCH FIELDS \ -->
                <div
                  class="salonhub-branche-fields"
                  v-if="activeCompData.apiItems.salonhub == true"
                >
                  <div class="salonhub-branche-fields-logo"></div>
                  <v-select
                    class="pt-2"
                    v-model="selectedBranch.branchNameSalonhub"
                    :items="activeCompData.salonhubApiSettings.salons"
                    hint="Welke naam gebruikt Salonhub voor deze vestiging?"
                    item-text="name"
                    item-value="salonhubid"
                    label="Vestigingsnaam Salonhub"
                    persistent-hint
                    outlined
                    dense
                    :color="companyPrimaryColor"
                  ></v-select>
                </div>
                <!-- \ SALONHUB BRANCH FIELDS / -->

                <!-- / DRUPAL BRANCH FIELDS \ -->

                <div
                  class="drupal-branche-fields"
                  v-if="activeCompData.apiItems.drupal == true"
                >
                  <div class="drupal-branche-fields-logo"></div>
                  <v-text-field
                    label="API url"
                    v-model="selectedBranch.drupalApiSettings.url"
                    outlined
                    :color="companyPrimaryColor"
                  ></v-text-field>
                  <v-switch
                    class="pa-0 ma-0"
                    :color="companyPrimaryColor"
                    v-model="selectedBranch.drupalApiSettings.basicAuth"
                    label="Basic HTTP Authentication"
                  >
                  </v-switch>

                  <div
                    class="drupal-basicauth-settings"
                    v-if="selectedBranch.drupalApiSettings.basicAuth == true"
                  >
                    <v-text-field
                      label="Username"
                      v-model="
                        selectedBranch.drupalApiSettings.basicAuthUsername
                      "
                      outlined
                      :color="companyPrimaryColor"
                      hide-details
                    ></v-text-field>

                    <v-text-field
                      class="pt-3"
                      label="Password"
                      v-model="
                        selectedBranch.drupalApiSettings.basicAuthPassword
                      "
                      outlined
                      :color="companyPrimaryColor"
                      hide-details
                    ></v-text-field>
                  </div>
                </div>
                <!-- \ DRUPAL BRANCH FIELDS / -->

                <v-layout row wrap>
                  <v-flex xs12 sm6 md9>
                    <v-text-field
                      class="pt-2"
                      label="Adres"
                      v-model="selectedBranch.address"
                      prepend-icon="place"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      class="pt-2"
                      label="huisnummer"
                      v-model="selectedBranch.number"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      class="pt-2"
                      label="Postcode"
                      v-model="selectedBranch.postalCode"
                      prepend-icon="null"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md9>
                    <v-text-field
                      class="pt-2"
                      label="Plaats"
                      v-model="selectedBranch.city"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="Provincie"
                      v-model="selectedBranch.province"
                      prepend-icon="null"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="Land"
                      v-model="selectedBranch.country"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="Telefoonnummer"
                      v-model="selectedBranch.phonenumber"
                      prepend-icon="null"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="E-mailadres"
                      v-model="selectedBranch.email"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <strong>Verzendtijd Review e-mails</strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              :color="$vuetify.theme.themes[theme].background"
            >
              <v-container class="pa-0 ma-0">
                <v-layout row wrap>
                  <v-flex xs12 style="padding: 10px 0">
                    <p>
                      Selecteerd de beste tijd zodat de mails na sluiting
                      verzonden worden.
                    </p>
                  </v-flex>

                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Zondag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="selectedBranch.ECsettings.Sun"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container class="pa-2 mx-0">
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Maandag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="selectedBranch.ECsettings.Mon"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="
                            $vuetify.theme.themes[theme].background
                          "
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Dinsdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="selectedBranch.ECsettings.Tue"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container class="pa-2 mx-0">
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Woensdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="selectedBranch.ECsettings.Wed"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="
                            $vuetify.theme.themes[theme].background
                          "
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Donderdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="selectedBranch.ECsettings.Thu"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container class="pa-2 mx-0">
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Vrijdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="selectedBranch.ECsettings.Fri"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="
                            $vuetify.theme.themes[theme].background
                          "
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Zaterdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="selectedBranch.ECsettings.Sat"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <strong>PDF Bon Footer</strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              :color="$vuetify.theme.themes[theme].background"
            >
              <v-container class="pa-0 ma-0">
                <v-layout row wrap>
                  <v-textarea
                    class="pt-5"
                    label="Footer tekst"
                    v-model="selectedBranch.receiptData.footer"
                    prepend-icon="notes"
                    required
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-textarea>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditCompDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed || busy"
              :depressed="!changed || busy"
              :dark="changed || busy"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updateBranch()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";

export default {
  name: "edit-branch-form",
  props: {
    selectedBranch: Object,
    selectedBranchOriginal: Object,
    activeCompData: Object,
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      feedback: null,
      errors: [],
      busy: false,
      panel: [0],
      surveySendTimes: [
        {
          name: "19:00u",
          value: "19",
        },
        {
          name: "21:00u",
          value: "21",
        },
      ],
    };
  },

  methods: {
    closeEditBranchDialog() {
      this.$emit("editBranchDialogChange", false);
      this.feedback = null;
    },

    updateBranch() {
      if (this.$refs.editBranchForm.validate()) {
        this.busy = true;
        let receiptBranchData = [
          "Salon",
          {
            style: "subheader",
            text:
              this.selectedBranch.address + " " + this.selectedBranch.number,
          },
          {
            style: "subheader",
            text: this.selectedBranch.phonenumber,
          },
          {
            style: "subheader",
            text: this.selectedBranch.email,
          },
          {
            style: "subheader",
            text: this.activeCompData.url,
          },
        ];

        db.collection("branches")
          .doc(this.selectedBranch.id)
          .set(
            {
              branchName: this.selectedBranch.branchName,
              branchNameSalonhub: this.selectedBranch.branchNameSalonhub,
              address: this.selectedBranch.address,
              number: this.selectedBranch.number,
              postalCode: this.selectedBranch.postalCode,
              city: this.selectedBranch.city,
              province: this.selectedBranch.province,
              country: this.selectedBranch.country,
              phonenumber: this.selectedBranch.phonenumber,
              email: this.selectedBranch.email,
              ECsettings: this.selectedBranch.ECsettings,
              receiptData: {
                branchData: receiptBranchData,
                footer: this.selectedBranch.receiptData.footer,
              },
              drupalApiSettings: {
                url: this.selectedBranch.drupalApiSettings.url,
                basicAuth: this.selectedBranch.drupalApiSettings.basicAuth,
                basicAuthUsername: this.selectedBranch.drupalApiSettings
                  .basicAuthUsername,
                basicAuthPassword: this.selectedBranch.drupalApiSettings
                  .basicAuthPassword,
              },
            },
            { merge: true },
          )
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Vestiging bewerkt: " + this.activeCompData.name,
              extra:
                "<b>ORGINELE GEGEVENS:</b><br>" +
                "<b>Naam vestiging:</b> " +
                this.selectedBranchOriginal.name +
                "<br>" +
                "<b>Naam vestiging Salonhub:</b> " +
                this.selectedBranchOriginal.branchNameSalonhub +
                "<br>" +
                "<b>Straat:</b> " +
                this.selectedBranchOriginal.address +
                "<br>" +
                "<b>Huisnummer:</b> " +
                this.selectedBranchOriginal.number +
                "<br>" +
                "<b>Postcode:</b> " +
                this.selectedBranchOriginal.postalCode +
                "<br>" +
                "<b>Plaats:</b> " +
                this.selectedBranchOriginal.city +
                "<br>" +
                "<b>Provincie:</b> " +
                this.selectedBranchOriginal.province +
                "<br>" +
                "<b>Land:</b> " +
                this.selectedBranchOriginal.country +
                "<br><br>" +
                "<b>Emotion Collect Verzendtijden:</b> " +
                this.selectedBranchOriginal.ECsettings +
                "<br><br>" +
                "<b>Drupal API Settings:</b> " +
                "<br>" +
                "<b>Url:</b> " +
                this.selectedBranchOriginal.drupalApiSettings.url +
                "<br>" +
                "<b>basicAuth:</b> " +
                this.selectedBranchOriginal.drupalApiSettings.basicAuth +
                "<br>" +
                "<b>basicAuthUsername:</b> " +
                this.selectedBranchOriginal.drupalApiSettings
                  .basicAuthUsername +
                "<br>" +
                "<b>basicAuthPassword:</b> " +
                this.selectedBranchOriginal.drupalApiSettings
                  .basicAuthPassword +
                "<br><br>" +
                "<b>AANGEPASTE GEGEVENS:</b><br>" +
                "<b>Naam vestiging:</b> " +
                this.selectedBranch.name +
                "<br>" +
                "<b>Naam vestiging Salonhub:</b> " +
                this.selectedBranch.branchNameSalonhub +
                "<br>" +
                "<b>Straat:</b> " +
                this.selectedBranch.address +
                "<br>" +
                "<b>Huisnummer:</b> " +
                this.selectedBranch.number +
                "<br>" +
                "<b>Postcode:</b> " +
                this.selectedBranch.postalCode +
                "<br>" +
                "<b>Plaats:</b> " +
                this.selectedBranch.city +
                "<br>" +
                "<b>Provincie:</b> " +
                this.selectedBranch.province +
                "<br>" +
                "<b>Land:</b> " +
                this.selectedBranch.country +
                "<br><br>" +
                "<b>Emotion Collect Verzendtijden:</b> " +
                this.selectedBranch.ECsettings +
                "<br><br>" +
                "<b>Drupal API Settings:</b> " +
                "<br>" +
                "<b>Url:</b> " +
                this.selectedBranch.drupalApiSettings.url +
                "<br>" +
                "<b>basicAuth:</b> " +
                this.selectedBranch.drupalApiSettings.basicAuth +
                "<br>" +
                "<b>basicAuthUsername:</b> " +
                this.selectedBranch.drupalApiSettings.basicAuthUsername +
                "<br>" +
                "<b>basicAuthPassword:</b> " +
                this.selectedBranch.drupalApiSettings.basicAuthPassword,
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditBranchDialog();
            this.busy = false;
            console.log("Branch succesfully updated");
            this.$refs.editBranchForm.reset();
          })
          .catch((error) => {
            console.error("Error updating Branch: ", error);
            this.busy = false;
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error updating Branch: " + this.activeCompName,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een vestiging toe te voegen.";
      }
    },
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    changed() {
      if (
        _.isEqual(this.selectedBranch, this.selectedBranchOriginal) == false
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
.expansion-card {
  background-color: #f6f7fb !important;
}
.expansion-card .v-card__text {
  border-top: 1px solid #e8e9ee;
}
</style>
